// @noflow
import './styles.css';

import classnames from 'classnames';
// import { Dropdown } from '~/components/widgets';
import Dropdown from '~/components/widgets/dropdown';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';

const propTypes = {
    className: PropTypes.string,
    currentIndex: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    handleSelection: PropTypes.func.isRequired,
    list: ImmutablePropTypes.list.isRequired
};

const GenericSelector = ({ className, currentIndex, description, handleSelection, list }) => {
    const color = className === 'then-consumer__selector--pale-grey' ? 'rgb(251, 251, 251)' : 'rgb(241, 241, 241)';
    return (
        <div className={classnames('generic-selector', className)}>
            <div className="generic-selector__description">{description}</div>
            {list.size === 1 && <span className="generic-selector__default-option">{list.get(currentIndex)}</span>}
            {list.size > 1 && (
                <div className="generic-selector__dropdown">
                    <Dropdown color={color} currentValue={currentIndex} handleChange={handleSelection} options={list} />
                </div>
            )}
        </div>
    );
};

GenericSelector.propTypes = propTypes;

export default GenericSelector;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/generic-selector/index.js